import { CheckBox } from "devextreme-react";
import * as React from "react";
import { useCallback } from "react";

interface IProps {
    text: string, value: any, checked: boolean, onCheckChanged: (value: any, checked: boolean) => void
}

const ValueCheckBox = ({ text, value, checked, onCheckChanged }: IProps) => {

    const onValueChangedHandler = useCallback((checked: any) =>
        onCheckChanged(value, checked), [value, onCheckChanged]);

    return <CheckBox
        text={text}
        value={checked}
        onValueChange={onValueChangedHandler}
    />
}

export default ValueCheckBox;